import { Button, message } from "antd";
import { FormDialog, FormLayout, FormItem } from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { message as messageService } from "@/services";
import ReportTypeSelect from "../ProcessMessage/ReportTypeSelect";
import PublicationSelect from "../ProcessMessage/PublicationSelect";

const schema = {
  type: "object",
  properties: {
    report_type: {
      type: "string",
      title: "采用类型",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "ReportTypeSelect",
      "x-component-props": "{{{token}}}",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    ReportTypeSelect,
    PublicationSelect,
  },
});

function MessageBackButton({
  type,
  size = "default",
  token,
  messageId,
  callback,
}) {
  return (
    <FormDialog.Portal>
      <Button
        type={type}
        size={size}
        onClick={() => {
          FormDialog({ title: "采用" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={16}>
                <SchemaField schema={schema} scope={{ token }} />
              </FormLayout>
            );
          })
            .forConfirm((payload, next) => {
              messageService
                .reportMessage(messageId, payload.values, token)
                .then((res) => {
                  message.success("操作成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      >
        采 用
      </Button>
    </FormDialog.Portal>
  );
}

export default MessageBackButton;
